var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import elasticlunr from 'elasticlunr';
import asciiFolder from 'fold-to-ascii';
import stemmerSupport from 'lunr-languages/lunr.stemmer.support';
import lunrSv from 'lunr-languages/lunr.sv';
import striptags from 'striptags';
import { UserRole } from './models';
var separationCharacter = ' ';
stemmerSupport(elasticlunr);
lunrSv(elasticlunr);
var replaceDiacritics = function (token) { return asciiFolder.foldReplacing(token); };
elasticlunr.Pipeline.registerFunction(replaceDiacritics, 'replaceDiacritics');
var SearchService = /** @class */ (function () {
    function SearchService(service, role, categoryPermissions, setupIndex) {
        var _this = this;
        if (setupIndex === void 0) { setupIndex = true; }
        if (setupIndex) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.setupSearchIndex(service, role, categoryPermissions);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        service.articleCollectionRef.onSnapshot(function (snapshot) {
            // TODO: Web and Mobile QuerySnapshot interface are different.
            var documentChange = [];
            if (snapshot) {
                if (typeof snapshot.docChanges === 'function') {
                    documentChange = snapshot.docChanges();
                }
                if (typeof snapshot.docChanges === 'object') {
                    documentChange = snapshot.docChanges;
                }
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            documentChange.forEach(function (change) {
                if (_this.searchIndex == null) {
                    return;
                }
                if (change.type === 'added') {
                    _this.searchIndex.addDoc(searchDocument(change.doc));
                }
                if (change.type === 'modified') {
                    _this.searchIndex.updateDoc(searchDocument(change.doc));
                }
                if (change.type === 'removed') {
                    _this.searchIndex.removeDoc(searchDocument(change.doc));
                }
            });
        });
    }
    SearchService.prototype.search = function (query) {
        return this.searchIndex
            .search(query.toLowerCase(), {
            fields: {
                title: { boost: 1 },
                content: { boost: 2 },
            },
            expand: true,
            bool: 'AND',
        })
            .map(function (resultItem) { return resultItem.ref; });
    };
    SearchService.prototype.setupSearchIndex = function (firebaseStore, role, categoryPermissions) {
        return __awaiter(this, void 0, void 0, function () {
            var chiefArticles, changelogArticles, permittedCategories, defaultArticles, allArticles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chiefArticles = [];
                        changelogArticles = [];
                        return [4 /*yield*/, firebaseStore.initPermittedCategories(role, categoryPermissions)];
                    case 1:
                        permittedCategories = _a.sent();
                        console.log('[@core/SearchService]  setupSearchIndex:', 'firebaseStore:', firebaseStore ? true : false, 'categories:', permittedCategories, 'role:', role);
                        return [4 /*yield*/, firebaseStore.fetchAllArticles()];
                    case 2:
                        defaultArticles = _a.sent();
                        if (!(role === UserRole.ADMIN || role === UserRole.SUPER_ADMIN)) return [3 /*break*/, 4];
                        return [4 /*yield*/, firebaseStore.fetchAllChiefArticles()];
                    case 3:
                        chiefArticles = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!permittedCategories.includes('changelog')) return [3 /*break*/, 6];
                        return [4 /*yield*/, firebaseStore.fetchAllChangelogArticles()];
                    case 5:
                        changelogArticles = _a.sent();
                        _a.label = 6;
                    case 6:
                        allArticles = defaultArticles.concat(chiefArticles, changelogArticles);
                        this.searchIndex = generateSearchIndex(allArticles);
                        return [2 /*return*/];
                }
            });
        });
    };
    return SearchService;
}());
export { SearchService };
export function generateSearchIndex(articles) {
    var searchIndex = elasticlunr(function (index) {
        index.addField('title');
        index.addField('content');
        index.setRef('id');
        index.saveDocument(false);
        index.use(elasticlunr.sv);
        index.pipeline.after(elasticlunr.sv.trimmer, replaceDiacritics);
    });
    articles.forEach(function (doc) {
        searchIndex.addDoc(searchDocument(doc));
    });
    return searchIndex;
}
export function searchDocument(doc) {
    var cleanEscapedContent = doc.data().content.replace(new RegExp('&nbsp;', 'g'), separationCharacter);
    var strippedAndDecoded = striptags(cleanEscapedContent, [], separationCharacter);
    return {
        id: doc.id,
        title: doc.data().name,
        content: strippedAndDecoded.replace(/  +/g, separationCharacter),
    };
}
//# sourceMappingURL=SearchService.js.map